import styled from "styled-components";
import { TablePageCard, TablePageContainer, TablePageTitle } from "components/TablePageLayout";
import { pxToRem } from "styles/utils";

export const Page = styled(TablePageContainer)`min-width: 0;`;
export const Content = styled(TablePageCard)`min-width: 0; overflow: auto; font-size:16px;
  input:not([type=checkbox]):not([type=radio]), textarea, select { font-size:16px; min-height:46px; }
  button, label { font-size:15px; } small { font-size:13px; }
  fieldset { min-width:0; } button { min-height:44px; }
`;
export const Header = styled.header`
  display: flex; flex-wrap: wrap; align-items: flex-start; justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.lg)}; margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xl)};
`;
export const Title = styled(TablePageTitle)``;
export const Subtitle = styled.p`margin: ${({ theme }) => pxToRem(theme.spacing.xs)} 0 0; color: ${({ theme }) => theme.colors.inkSoft}; line-height: 1.5;`;
export const Actions = styled.div`
  display: flex; flex-wrap: wrap; gap: ${({ theme }) => pxToRem(theme.spacing.sm)};
  @media (max-width: 720px) { width: 100%; }
`;
export const Button = styled.button<{ $primary?: boolean }>`
  min-height: ${pxToRem(46)}; padding: ${pxToRem(10)} ${({ theme }) => pxToRem(theme.spacing.lg)};
  border: 1px solid ${({ theme }) => theme.colors.brand}; border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme, $primary }) => $primary ? theme.colors.brand : theme.colors.white};
  color: ${({ theme, $primary }) => $primary ? theme.colors.white : theme.colors.brand}; font: inherit; font-weight: 600; cursor: pointer;
  &:disabled { opacity: .55; cursor: wait; }
  @media (max-width: 720px) { flex: 1 1 ${pxToRem(180)}; }
`;
export const FileUploadLabel = styled.label`
  display: inline-flex; align-items: center; justify-content: center; min-height: ${pxToRem(48)}; margin: ${pxToRem(12)} 0;
  padding: ${pxToRem(10)} ${pxToRem(20)}; border-radius: ${pxToRem(12)}; background: #7246e5; color: white;
  font-size: ${pxToRem(15)}; font-weight: 700; cursor: pointer;
  input { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; }
  &:focus-within { outline: 3px solid rgba(49, 185, 121, .35); outline-offset: 2px; }
`;
export const AddBlockGrid = styled.div`
  display: grid; grid-template-columns: repeat(auto-fit, minmax(${pxToRem(190)}, 1fr)); gap: ${pxToRem(12)};
  & > button { min-height: ${pxToRem(58)}; justify-content: flex-start; text-align: left; font-size: ${pxToRem(15)}; }
`;
export const EditorPreviewGrid = styled.div`
  display: grid; grid-template-columns: minmax(280px, .7fr) minmax(0, 1.3fr); gap: 24px; align-items: start;
  & > * { min-width: 0; }
  fieldset, label, p, a { min-width: 0; max-width: 100%; overflow-wrap: anywhere; }
  section[id^="site-block-editor-"] { scroll-margin-block: 20px; }
  @media (max-width: 1100px) { grid-template-columns: 1fr; }
`;
export const StickyPreview = styled.aside`
  position: sticky; top: ${pxToRem(16)}; min-width: 0;
  @media (max-width: 1100px) { position: static; }
`;
export const PreviewBrowser = styled.div`
  width: 100%; max-width: 100%; overflow: hidden; border: 1px solid ${({ theme }) => theme.borders.outline}; border-radius: 16px; background: white;
  box-shadow: 0 18px 50px rgba(35, 20, 80, .10);
`;
export const PreviewBar = styled.div`
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px; padding: 14px 18px;
  border-bottom: 1px solid ${({ theme }) => theme.borders.outline}; background: white;
  strong { color: ${({ theme }) => theme.colors.brand}; font-size: 18px; }
  nav { display: flex; flex-wrap: wrap; gap: 8px; min-width: 0; }
  button { border: 0; background: transparent; color: ${({ theme }) => theme.colors.ink}; font: inherit; font-weight: 600; cursor: pointer; }
`;
export const PreviewHelp = styled.p`
  margin: 0 0 12px; padding: 12px 14px; border-radius: 12px; background: #eaf8f1; color: #176c47; line-height: 1.45;
`;
export const Grid = styled.div`
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: ${({ theme }) => pxToRem(theme.spacing.lg)};
  @media (max-width: 850px) { grid-template-columns: 1fr; }
`;
export const Card = styled.section`
  min-width: 0; padding: ${({ theme }) => pxToRem(theme.spacing.xl)}; border: 1px solid ${({ theme }) => theme.borders.outline};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)}; background: ${({ theme }) => theme.colors.white};
`;
export const CardTitle = styled.h2`margin: 0 0 18px; color: ${({ theme }) => theme.colors.ink}; font-size: 20px; line-height:1.4;`;
export const Label = styled.label`display: grid; gap: ${({ theme }) => pxToRem(theme.spacing.xs)}; margin-bottom: ${({ theme }) => pxToRem(theme.spacing.md)}; color: ${({ theme }) => theme.colors.ink}; font-size: ${pxToRem(15)}; line-height: 1.45; font-weight: 600;`;
export const Input = styled.input`
  width: 100%; min-width: 0; min-height: ${({ theme }) => pxToRem(theme.controlHeight.md)}; box-sizing: border-box;
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.md)}; border: 1px solid ${({ theme }) => theme.borders.field}; border-radius: ${({ theme }) => pxToRem(theme.radii.md)}; font: inherit;
`;
export const Textarea = styled.textarea`
  width: 100%; min-width: 0; min-height: ${pxToRem(130)}; box-sizing: border-box; resize: vertical;
  padding: ${({ theme }) => pxToRem(theme.spacing.md)}; border: 1px solid ${({ theme }) => theme.borders.field}; border-radius: ${({ theme }) => pxToRem(theme.radii.md)}; font: inherit; line-height: 1.5;
`;
export const Status = styled.div`
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.lg)}; padding: ${({ theme }) => pxToRem(theme.spacing.md)} ${({ theme }) => pxToRem(theme.spacing.lg)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)}; background: ${({ theme }) => theme.colors.surfaceCool}; color: ${({ theme }) => theme.colors.inkSoft}; overflow-wrap: anywhere;
`;
export const ErrorText = styled.p`color: ${({ theme }) => theme.colors.dangerText};`;
export const BuilderNav = styled.nav`
  display: flex; flex-wrap: wrap; gap: ${({ theme }) => pxToRem(theme.spacing.sm)}; margin: 0 0 ${({ theme }) => pxToRem(theme.spacing.xl)};
`;
export const NavTab = styled.button<{ $active?: boolean }>`
  min-height: ${pxToRem(42)}; padding: 0 ${({ theme }) => pxToRem(theme.spacing.lg)}; border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  border: 1px solid ${({ theme }) => theme.colors.brand}; background: ${({ theme, $active }) => $active ? theme.colors.brand : theme.colors.white};
  color: ${({ theme, $active }) => $active ? theme.colors.white : theme.colors.brand}; font: inherit; font-weight: 600; cursor: pointer;
`;
export const PageCard = styled.button`
  display: grid; grid-template-columns: auto 1fr auto; align-items: center; gap: ${({ theme }) => pxToRem(theme.spacing.lg)}; width: 100%;
  padding: ${({ theme }) => pxToRem(theme.spacing.xl)}; border: 1px solid ${({ theme }) => theme.borders.outline}; border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.white}; color: ${({ theme }) => theme.colors.ink}; text-align: left; font: inherit; cursor: pointer;
  &:hover, &:focus-visible { border-color: ${({ theme }) => theme.colors.brand}; box-shadow: 0 12px 30px rgba(77, 48, 164, .08); }
  @media (max-width: 600px) { grid-template-columns: 1fr; }
`;
export const PageIcon = styled.span`display: grid; place-items: center; width: ${pxToRem(48)}; height: ${pxToRem(48)}; border-radius: ${pxToRem(14)}; background: #f1edff; color: #7047df; font-size: ${pxToRem(22)};`;
export const PreviewShell = styled.div<{ $mobile?: boolean }>`
  width: ${({ $mobile }) => $mobile ? "390px" : "100%"}; max-width: 100%; margin: ${({ $mobile }) => $mobile ? "0 auto" : "0"};
  height: min(78vh, 900px); min-height: 500px; padding: 0; box-sizing: border-box;
  background: white; overflow-y: auto; overflow-x: hidden; scroll-behavior: smooth;
`;

export const PublicPage = styled.div`min-height: 100vh; background: white; color: #17102f; font-size:18px; input, textarea, button, label { font-size:16px; }`;
export const PublicHeader = styled.header`
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 16px; padding: 22px clamp(20px, 6vw, 80px); background: white; border-bottom: 1px solid #e7e2f2;
`;
export const Brand = styled.strong`color: #744ceb; font-size: 24px;`;
export const PublicNav = styled.nav`display: flex; flex-wrap: wrap; gap: 10px;`;
export const NavButton = styled.button<{ $active?: boolean }>`border: 0; border-radius: 10px; padding: 10px 14px; background: ${({ $active }) => $active ? "#744ceb" : "#f1edff"}; color: ${({ $active }) => $active ? "white" : "#4f2dbd"}; font: inherit; cursor: pointer;`;
export const Hero = styled.main`max-width: 1440px; margin: 0 auto; padding: 0; & > h1, & > p { margin:40px 4%; } & > #application { margin:60px auto; max-width:720px; padding:32px; }`;
export const HeroTitle = styled.h1`margin: 0; font-size: clamp(34px, 6vw, 64px); line-height: 1.1;`;
export const HeroText = styled.p`max-width: 760px; margin-top: 24px; font-size: clamp(17px, 2.2vw, 22px); line-height: 1.7; white-space: pre-wrap;`;
